import { useState } from 'react';
import { Badge, InlineStack, Page, Text } from '../components/admin-ui';
import EmailSenderSettings from '../components/EmailSenderSettings';
import EmailContentEditor from '../components/EmailContentEditor';
import EmailSendingHistory from '../components/EmailSendingHistory';
import './EmailMarketing.css';

export default function EmailMarketing() {
  const [active, setActive] = useState(null);
  return <Page><div className="email-marketing">
    <InlineStack align="space-between" blockAlign="center" gap="300">
      <Text as="p" tone="subdued">Manage your sender, email content, and sending history.</Text>
      {active !== null && <Badge tone={active ? 'success' : undefined}>{active ? 'Sending enabled' : 'Sending paused'}</Badge>}
    </InlineStack>
    <div className="email-editor-grid"><EmailSenderSettings onStatus={setActive} /><EmailContentEditor /></div>
    <EmailSendingHistory />
  </div></Page>;
}
